/**
 * @generated SignedSource<<dfb608f9d3026f3f5afd46d9e428dc29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShippingForm_viewer$data = {
  readonly __typename: "Viewer";
  readonly enableCheckoutAddressAutocomplete: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRegistrationForm_viewer" | "ControlledAddressForm_viewer">;
  readonly " $fragmentType": "CheckoutShippingForm_viewer";
};
export type CheckoutShippingForm_viewer$key = {
  readonly " $data"?: CheckoutShippingForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShippingForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutRegistrationForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ControlledAddressForm_viewer"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": "enableCheckoutAddressAutocomplete",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "checkoutAddressAutocomplete"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"checkoutAddressAutocomplete\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "96ad076abae1c7d10bf5aa19e14daf46";

export default node;
